//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import axios from "axios"

export default {
  name: 'CommunityPlaylist',
  components: {
  },
  data: function() {
    return {
      is_downloading: false,
      patterns: [],
      apatterns: [],
      allPatterns: [],
      existingPatterns: []
    }
  },
  methods: {
    downloadPlaylist: async function() {
      this.$q.loading.show({
        delay: 400 // ms
      })

      //Download all patterns that don't currently exist on SPIFFS
      for(let i = 0; i < this.apatterns.length; i++) {
        const pattern = this.apatterns[i];
        if(!pattern.is_downloaded) {
          await this.downloadPattern(pattern);
        }
      }

      //Generate sequence file and upload to robot
      let seqFile = "";
      for(let i = 0; i < this.apatterns.length; i++) {
        const pattern = this.apatterns[i];
        seqFile += pattern.track_id + "-" + pattern.name.replace(/-/g, "") + ".thr\n";
      }

      var formData = new FormData();
      var blob = new Blob([seqFile], {type: "text/plain"});
      formData.append("file", blob, this.$route.params.id + "-" + this.$route.params.name.replace(/-/g, "") + ".seq");
      await axios.post(this.$root.baseURL + "/uploadtofileman", formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
      });

      console.log(seqFile);

      this.$q.loading.hide();
    },
    downloadPattern: async function(pattern) {
      pattern.is_downloading = true;

      //Get pattern data from Webcenter
      const ptData = (await axios.get("https://webcenter.sisyphus-industries.com/tracks/" + pattern.track_id + "/download.json", { headers: {Authorization: this.$root.community.authToken }})).data.resp;
      var formData = new FormData();
      var blob = new Blob([ptData], {type: "text/plain"});
      formData.append("file", blob, pattern.track_id + "-" + pattern.name.replace(/-/g, "") + ".thr");
      await axios.post(this.$root.baseURL + "/uploadtofileman", formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
      });
      pattern.is_downloading = false;
      pattern.is_downloaded = true;
    },
    loadMoreTracks: function(index, done) {
      let i = 0;
      this.allPatterns.forEach(pattern => {
        i++;
        if(i < 10) {
          this.allPatterns.shift();
          this.patterns.push(pattern);
        }
      })
      done()
    },
    openPlaylist: function(pname) {
      this.$router.push("/community/playlist/" + pname);
    },
    refreshFiles: async function(done) {
      if(this.$root.community.authToken == "") {
          //Log in to Webcenter
          await axios.post("https://webcenter.sisyphus-industries.com/auth_user", {
              email: this.$root.community.email, password: this.$root.community.password
          }).then((resp) => {
              this.$root.community.authToken = resp.data.resp[0].auth_token;
          });
      }

      //Get all files on bot
      await axios.get(this.$root.baseURL + "/filelist").then((response) => {
        response.data.files.forEach(file => {
          if(file.name.includes(".thr") || file.name.includes(".THR")) {
            //thr
            this.existingPatterns.push(file.name.split("-")[0]);
          }
        });
      });

      //Get popular tracks
      await axios.get("https://webcenter.sisyphus-industries.com/playlists/" + this.$route.params.id + ".json", { headers: {Authorization: this.$root.community.authToken }}).then((response) => {
        const tracks = response.data.resp;
        tracks.forEach(track => {
          if(track.type == "track") {
            track.is_downloading = false
            track.is_downloaded = false
            if(this.existingPatterns.includes(track.track_id)) {
              track.is_downloaded = true
            }
            this.apatterns.push(track)
            this.allPatterns.push(track)
          }
        });
      });

      //load first ten patterns into list
      let i = 0;
      this.allPatterns.forEach(pattern => {
        i++;
        if(i < 10) {
          this.allPatterns.shift();
          this.patterns.push(pattern);
        }
      })
      done();
    }
  },
  mounted: function() {
    this.refreshFiles();
  }
}
